export const USER_TYPE = {
    OKTA: 'Okta',
    NORMAL: 'Normal',
    CUSTOMER: 'Customer'
}

export const COLOR_SERIES = ['#00bbc4', '#00a8ce', '#008fcd', '#8072bb', '#b35295', '#c43465', '#da1457', '#d314da', '#ac14da', '#6328c9', '#2868c9', '#28c9c4']


// billing configurator
export const BILLING_PLAN_STATUS = {
    DRAFT: 'Draft',
    PENDING_APPROVAL: 'Pending Approval',
    APPROVED: 'Approved',
}
export const CSP_TYPE = {
    AWS: 'aws',
    AZURE: 'azure',
    GCP: 'gcp',
    OCI: 'oci'
}
export const CERT_TYPES = {
    "Associate": 'Associate',
    "Professional": 'Professional',
    "Infrastructure as Code": 'Automation',
    "Operations": 'Operations',
    "Associate SAP": 'Associate SAP',
    "Managed Service Providers":'Managed Service Providers',
    "Cloud Backbone and Hybrid Connectivity": 'Cloud Backbone',
    "Network Security": 'Network Security',
    "Hybrid Cloud": 'Hybrid Cloud',
}

// parameter groupping
export const SECURITY_SERVICES_PARAMS = ['fqdn_gw', 'private_s3_gws', 'psf_guard_gw', 'psf_noguard_gw'];
export const INTER_TUNNEL_PARAMS = ['s2s_inter_att', 's2t_hpe_inter_att', 't2t_hpe_inter_att', 's2t_inter_att', 't2t_inter_att'];
export const INTRA_TUNNEL_PARAMS = ['s2t_intra_att', 's2s_intra_att', 't2t_hpe_intra_att', 't2t_intra_att'];


export const ELP_BILLING_PLANS = {
    METER_ELP_TIERS: 'METER_ELP_TIERS',
    METER_ELP_VOLUME: 'METER_ELP_VOLUME',
    FIXED_ELP_MONTHLY_BILL: 'FIXED_ELP_MONTHLY_BILL',
    FIXED_ELP_ONETIME_UPFRONT_BILL: 'FIXED_ELP_ONETIME_UPFRONT_BILL',
    FLEX_OVERAGES_PAY_SCHEDULE:'FLEX_OVERAGES_PAY_SCHEDULE',
    FIXED_ELP_FLEXIBLE_PAYMENT: 'FIXED_ELP_FLEXIBLE_PAYMENT'

}
export const ELP_BILLING_PLANS_TITLE = {
    // [ELP_BILLING_PLANS.METER_ELP_TIERS]: 'Metered ELP with Discount Tiers and Minimum Spend Commitment',
    // [ELP_BILLING_PLANS.METER_ELP_VOLUME]: 'Metered ELP with Volume Discount and Minimum Spend Commitment',
    [ELP_BILLING_PLANS.FIXED_ELP_MONTHLY_BILL]: 'Metered ELP with Fixed Monthly Commitment and Overages',
    [ELP_BILLING_PLANS.FIXED_ELP_ONETIME_UPFRONT_BILL]: 'Fixed ELP With One-Time Upfront Billing + Monthly Overages',
    [ELP_BILLING_PLANS.FLEX_OVERAGES_PAY_SCHEDULE]: 'Flexible Overages Payment Schedule'
    //[ELP_BILLING_PLANS.FIXED_ELP_FLEXIBLE_PAYMENT]: 'ELP Fixed Term Payment Plan'

}

export const ORG_INFO_ENDPOINTS = {
    CODA_IO:"https://coda.io/apis/v1/docs/e9jp5hsnkT/tables/grid-3pNDTAs_WZ/rows",
    RIPPLING:"https://api.rippling.com/platform/api/employees"
}

export const MB_ORG_INFO_ENDPOINTS = {
    sfdc_ACCOUNT: "https://xqgt-wcpg-w78i.aviatrix.xano.io/api:cmUD4S0D/sfdc_account?"
}
export const STATIC_IMG = "https://camo.githubusercontent.com/079ab773441b0a8a7ba0daeb317d6fe0c3f4e3d077630fd2fda927db6bf4b09b/68747470733a2f2f612e736c61636b2d656467652e636f6d2f64663130642f696d672f617661746172732f6176615f303032322d3531322e706e67"

export const ACCOUNT_DESCRIPTION = {
    'VPC-to-VPC Inter Cloud Connection Hours': 'Aviatrix managed secure application connectivity between multiple clouds and to hybrid on-premise',
    'VPC-to-VPC Intra Cloud Connection Hours': 'Aviatrix managed secure application connectivity within regions of a single cloud',
    'Gateways Running Security Services Hours': 'Aviatrix security-enabled software appliances protecting application data',
    'VPN Users Licensed': 'Aviatrix managed application VPCs/VNETs/VCNs',
    'Bandwidth (MB)': 'The amount of application data traffic egressing Aviatrix gateways running security',
    'Firenet VPC': 'Aviatrix service insertion of FWs for Application Security',
    'Transit GW': 'Aviatrix GWs providing secure transit connection between application environments',
    'TGW Attachments': 'Aviatrix orchestrating AWS Transit Gateway based application environments',
    'NAT Enabled': 'Aviatrix secure software appliances connecting application environments with specialized addressing needs',
    'Max Service Node Count': 'Total number of Aviatrix billing units for non metered customer',
    'Firenet Firewall Inst': 'Aviatrix turnkey or ready-made network solution to deploy firewall instances in the cloud',
    'PSF Guard GW': 'Public subnet filtering gateway via guard duty',
    'PSF NoGUARD GW': 'Public subnet filtering gateway via no guard duty'
}

export const QUOTE_STATUSES = {
    'DRAFT':'Draft',
    'PENDING':'Pending',
    'APPROVED':'Approved',
    'REJECTED':'Rejected',
    'PREVIEW':'PREVIEW'
}


export const Countries_List = [
    "Afghanistan",
    "Aland Islands",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antarctica",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia, Plurinational State of",
    "Bonaire, Sint Eustatius and Saba",
    "Bosnia and Herzegovina",
    "Botswana",
    "Bouvet Island",
    "Brazil",
    "British Indian Ocean Territory",
    "Brunei Darussalam",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos (Keeling) Islands",
    "Colombia",
    "Comoros",
    "Congo",
    "Congo, the Democratic Republic of the",
    "Cook Islands",
    "Costa Rica",
    "Cote d’Ivoire",
    "Croatia",
    "Cuba",
    "Curaçao",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Falkland Islands (Malvinas)",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern Territories",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Heard Island and McDonald Islands",
    "Holy See (Vatican City State)",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran, Islamic Republic of",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea, Democratic People’s Republic of",
    "Korea, Republic of",
    "Kuwait",
    "Kyrgyzstan",
    "Lao People’s Democratic Republic",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao",
    "Macedonia, the former Yugoslav Republic of",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Moldova, Republic of",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "Norway",
    "Oman",
    "Pakistan",
    "Palestine",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Pitcairn",
    "Poland",
    "Portugal",
    "Qatar",
    "Reunion",
    "Romania",
    "Russian Federation",
    "Rwanda",
    "Saint Barthélemy",
    "Saint Helena, Ascension and Tristan da Cunha",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Martin (French part)",
    "Saint Pierre and Miquelon",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Sint Maarten (Dutch part)",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Georgia and the South Sandwich Islands",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Svalbard and Jan Mayen",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syrian Arab Republic",
    "Taiwan",
    "Tajikistan",
    "Tanzania, United Republic of",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks and Caicos Islands",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela, Bolivarian Republic of",
    "Vietnam",
    "Virgin Islands, British",
    "Wallis and Futuna",
    "Western Sahara",
    "Yemen",
    "Zambia",
    "Zimbabwe"
]

export const Account_Types = [
    "Prospect", "Customer", "Partner","Competitor"
]
export const Market_Segments = [
    "Commercial", "Enterprise"
]
export const AnnualBrandRevenue = [
    "Over $5 bil.",
    "$1 bil. - $5 bil.",
    "$100 mil. - $250 mil.",
    "$250 mil. - $500 mil.",
    "$10 mil. - $25 mil.",
    "$500 mil. - $1 bil.",
    "$50 mil. - $100 mil.",
    "$25 mil. - $50 mil.",
    "$5 mil. - $10 mil.",
    "$1 mil. - $5 mil.",
    "$500,000 - $1 mil.",
    "Under $500,000",
    "$100 mil. - $500 mil.",
    "7764600"
]

export const EDGE_NOTIFICATION ={
    ADMIN:'edgeAdmin@aviatrix.com',
    SUPERVISOR:'mkaniganti@aviatrix.com'
} 

export const HV_CATEGORY_LIST = [
    {
        key: "Network Archictect",
        val: "Network Archictect"
    },
    {
        key: "Cloud Architect",
        val: "Cloud Architect"
    },
    {
        key: "Network Engineer",
        val: "Network Engineer"
    },
    {
        key: "Cloud Engineer",
        val: "Cloud Engineer"
    }
]

export const HV_SMARTPROFILE_STATUS = [
    {
        key: "enriched",
        val: "Enriched"
    },
    {
        key: "processed",
        val: "Processed"
    },
    {
        key: "processing",
        val: "Processing"
    },
    {
        key: "failed",
        val: "Failed"
    }
]
export const Account_Industries = [
    "Industry",
    "Research & Consulting Services",
    "Grocery Retail",
    "Appliances",
    "Telecommunications",
    "Machinery",
    "Architecture & Planning",
    "Healthcare Services",
    "Local",
    "Consulting",
    "Media",
    "Industrial Automation",
    "Food Products",
    "Energy, Utilities & Waste",
    "Medical & Surgical Hospitals",
    "Food & Beverage",
    "Market Research",
    "Accounting",
    "Investment Banking",
    "Human Resources",
    "Chemicals & Related Products",
    "Movies & Entertainment",
    "Integrated Telecommunication Services",
    "Government Administration",
    "Distributors",
    "Civil Engineering Construction",
    "Lodging & Resorts",
    "Cloud Services",
    "Consumer Staples",
    "Colleges & Universities",
    "ISP",
    "Defense Space",
    "Electric and Gas Utilities",
    "Technology - Other",
    "Internet Software & Services",
    "Diversified Telecommunication Services",
    "Fitness & Dance Facilities",
    "Law Firms & Legal Services",
    "Renewable Electricity",
    "Telephony & Wireless",
    "Publishing",
    "Professional Services Media Telco",
    "Recreation",
    "Performing Arts",
    "Media and Entertainment",
    "Restaurants",
    "Apparel & Accessories Retail",
    "Gambling & Gaming",
    "Membership Organizations",
    "Computer Networking",
    "Financial Software",
    "Automotive",
    "Freight & Logistics Services",
    "Cleaning Products",
    "Cable & Satellite",
    "Physicians Clinics",
    "Water Treatment",
    "Electronics",
    "Government Relations",
    "Software",
    "Medical Laboratories & Imaging Centers",
    "Software & Internet",
    "Electricity, Oil & Gas",
    "Business Services",
    "Home Improvement & Hardware Retail",
    "Technology Hardware, Storage & Periph...",
    "Consumer Services",
    "Electronic Components",
    "Information Technology & Services",
    "Medical Devices",
    "Computer and Technology",
    "Veterinary Services",
    "Investment Management",
    "Motor Vehicles",
    "Mining Metals",
    "Professional Services",
    "IT Services",
    "Automotive Service & Collision Repair",
    "It Channel/Distributor/Other Tech",
    "Oil & Gas",
    "Emergency Medical Transportation & Services",
    "Information & Document Management",
    "Rail, Bus & Taxi",
    "Facilities Management & Commercial Cleaning",
    "State",
    "Education Management",
    "Credit Cards & Transaction Processing",
    "Miscellaneous Services",
    "Biotechnology",
    "Office Products Retail & Distribution",
    "Government - State/Local",
    "Food",
    "Trading Companies & Distributors",
    "Database & File Management Software",
    "Academia",
    "Computer Software",
    "Manufacturer",
    "Health & Wellness",
    "Commercial Printing",
    "Research & Development",
    "Travel Agencies & Services",
    "Custom Software & IT Services",
    "Business Intelligence (BI) Software",
    "Consumer Goods",
    "Pulp & Paper",
    "Automobile Parts Stores",
    "Education",
    "Furniture",
    "Chemicals",
    "Media Production",
    "Primary/Secondary Education",
    "Health Care Providers & Services",
    "Health",
    "Banks",
    "Business Supplies",
    "Customer Relationship Management (CRM) Software",
    "Building Materials",
    "Blood & Organ Banks",
    "Retail",
    "Security software",
    "Diversified Financial Services",
    "Computer Equipment & Peripherals",
    "Automobile Dealers",
    "Landscape Services",
    "Nonprofit Organization Management",
    "Civic & Social Organization",
    "Technology - Software & Services",
    "Government",
    "Hospitality",
    "Other",
    "Higher Education",
    "Agriculture",
    "Logistics",
    "Construction & Engineering",
    "Computer Hardware",
    "Energy",
    "Travel Transport Logistics",
    "Communications",
    "Jewelry & Watch Retail",
    "(MSP) Managed Service Provider and/or (CSP) Cloud Service Provider",
    "Public Sector -Healthcare",
    "Transportation",
    "Education and Training",
    "Telecommunication Equipment",
    "Pet Products",
    "(MSSP) Managed Security Service Provider",
    "Banking",
    "Textiles & Apparel",
    "Pharmaceuticals",
    "Department Stores, Shopping Centers & Superstores",
    "Media & Internet",
    "Organizations",
    "Airlines, Airports & Air Services",
    "Military",
    "Communications Equipment",
    "Public Sector: Government + Federal",
    "Networking Software",
    "Holding Companies & Conglomerates",
    "Cultural & Informational Centers",
    "Venture Capital & Private Equity",
    "Retailers",
    "Technology",
    "Research",
    "Education Services",
    "Design",
    "Engineering",
    "Retailing",
    "Data Collection & Internet Portals",
    "Industrial Machinery & Equipment",
    "Internet",
    "Test & Measurement Equipment",
    "Oil & Energy",
    "Service Provider",
    "Advertising & Marketing",
    "IT Channel/Distributor",
    "Medical Specialists",
    "Mental Health & Rehabilitation Facilities",
    "Healthcare",
    "Outsourcing/Offshoring",
    "Information Technology and Services",
    "Lending & Brokerage",
    "Enterprise Resource Planning (ERP) Software",
    "Debt Collection",
    "HR & Staffing",
    "Information Technology",
    "Animals & Livestock",
    "Manufacturing",
    "Hotels, Restaurants & Leisure",
    "Sporting & Recreational Equipment Retail",
    "Automation",
    "Management Consulting",
    "Household Goods",
    "Gas Utilities",
    "Real Estate",
    "Electrical Equipment",
    "Renewable Energy",
    "Consumer Electronics & Computers Retail",
    "Wholesalers",
    "Hospital & Health Care",
    "Entertainment",
    "Utilities",
    "Content & Collaboration Software",
    "Wireless/Satellite/Telecom",
    "Financial Services",
    "Public Sector - Education",
    "Broadcasting",
    "Aerospace & Defense",
    "Non profit Organizations",
    "Services - Other",
    "Non-Profit & Charitable Organizations",
    "State and Local",
    "Electrical",
    "Commercial & Residential Construction",
    "Diversified Consumer Services",
    "Training",
    "Repair Services",
    "Barber Shops & Beauty Salons",
    "Computers & Electronics",
    "Computer & Network Security",
    "Airlines",
    "Photography Studio",
    "Multimedia & Graphic Design",
    "Vitamins, Supplements & Health Stores",
    "Federal",
    "Manufacturer devices",
    "Construction",
    "Hospitals & Clinics",
    "Hospitals & Physicians Clinics",
    "Minerals & Mining",
    "Metals & Mining"
]